/* src/app/shared/dialogs/confirm-download-dialog/confirm-download-dialog.component.scss */
.dialog-main-container {
  display: flex;
  flex-direction: column;
  width: 580px;
  height: 100vh;
  position: relative;
}
.header-container {
  display: flex;
  flex-direction: row;
  width: 100%;
  justify-content: space-between;
  align-items: center;
  padding: 24px;
  border-bottom: 1px solid #dfdfdf;
}
.dialog-content {
  flex: 1;
  overflow-y: auto;
  padding-bottom: 96px;
}
.dialog-body {
  height: auto;
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 24px;
  padding: 24px;
}
.dialog-section {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  height: auto;
}
.section-info-container {
  display: flex;
  flex-direction: column;
  width: 50%;
  height: auto;
}
.preview-section {
  width: 100%;
  gap: 8px;
}
.title {
  font-family: "Poppins-Regular";
  font-size: 18px;
  font-style: normal;
  line-height: 24px;
  color: #222222;
}
.section-title {
  font-family: "Poppins-Regular";
  font-size: 14px;
  font-style: normal;
  line-height: 24px;
  color: #222222;
}
.section-info {
  font-family: "Poppins-Regular";
  font-size: 14px;
  font-style: normal;
  line-height: 24px;
  color: #a6a6a6;
}
.bottom-wrapper {
  display: flex;
  flex-direction: column;
  gap: 24px;
  padding: 24px;
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  z-index: 1;
  background: #ffffff;
}
.buttons-container {
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  align-items: center;
  width: 100%;
  gap: 16px;
}
.preview-container {
  padding: 8px;
  background-color: #f5f5f5;
  border-radius: 12px;
}
/*# sourceMappingURL=confirm-download-dialog.component.css.map */
